// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import styled from "styled-components";

interface OwnProps {
    url: string;
}

const PdfWrapper = styled.div`
    width: 100%;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    border: ${pxToRem(1)} solid ${getColor("common.border")};
    margin-bottom: ${pxToRem(15)};
    padding: ${pxToRem(15)};
`;

const PdfFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
`;

export const PartFinderSchemaPdf = ({ url }: OwnProps) => {
    return (
        <PdfWrapper>
            <PdfFrame src={`${url}#view=FitH`} title="PDF Viewer" />
        </PdfWrapper>
    );
};
